// User
export const SET_USER = 'SET_USER';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const LOADING_USER = 'LOADING_USER';

// Article
export const ADD_ARTICLE = 'ADD_ARTICLE';
export const SET_ARTICLES = 'SET_ARTICLES';
export const LOADING_ARTICLES = 'LOADING_ARTICLES';

// UI
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_UI = 'LOADING_UI';
